import { render, staticRenderFns } from "./ListaContasBancarias.vue?vue&type=template&id=473bf45f&scoped=true"
import script from "./ListaContasBancarias.vue?vue&type=script&lang=js"
export * from "./ListaContasBancarias.vue?vue&type=script&lang=js"
import style0 from "./ListaContasBancarias.vue?vue&type=style&index=0&id=473bf45f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473bf45f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VChip,VIcon,VList,VListItem,VListItemTitle,VMenu})
